export const WAREHOUSE_SYNC_SESSION_STATUS_VALUES = {
  diffing: 'diffing',
  syncing: 'syncing',
  validating: 'validating',
  completed: 'completed',
  failed: 'failed',
} as const;

export type WarehouseSyncSessionStatus =
  (typeof WAREHOUSE_SYNC_SESSION_STATUS_VALUES)[keyof typeof WAREHOUSE_SYNC_SESSION_STATUS_VALUES];
